import Icon from "@ant-design/icons";

const CustomIcon = ({ width = 16, height = 16, color = "#F0552D" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
        >
            <rect
                width={width}
                height={height}
                fill="white"
                fill-opacity="0.01"
            />
            <path
                d="M8.00013 1.00001C7.07929 0.994302 6.16647 1.17146 5.31461 1.52123C4.46275 1.87099 3.68881 2.38639 3.03766 3.03754C2.38651 3.68869 1.87111 4.46263 1.52135 5.31449C1.17159 6.16634 0.994424 7.07916 1.00013 8.00001C0.994424 8.92086 1.17159 9.83368 1.52135 10.6855C1.87111 11.5374 2.38651 12.3113 3.03766 12.9625C3.68881 13.6136 4.46275 14.129 5.31461 14.4788C6.16647 14.8286 7.07929 15.0057 8.00013 15C8.92098 15.0057 9.8338 14.8286 10.6857 14.4788C11.5375 14.129 12.3115 13.6136 12.9626 12.9625C13.6138 12.3113 14.1292 11.5374 14.4789 10.6855C14.8287 9.83368 15.0058 8.92086 15.0001 8.00001C15.0058 7.07916 14.8287 6.16634 14.4789 5.31449C14.1292 4.46263 13.6138 3.68869 12.9626 3.03754C12.3115 2.38639 11.5375 1.87099 10.6857 1.52123C9.8338 1.17146 8.92098 0.994302 8.00013 1.00001ZM10.7226 11.5L4.50013 5.27786L5.27798 4.50001L11.5001 10.7224L10.7226 11.5Z"
                fill={color}
            />
        </svg>
    );
};

export const ErrorIcon = (props) => <Icon component={CustomIcon} {...props} />;
